// removed by extract-text-webpack-plugin
module.exports = {"headerText":"_3_6SEuYFp4A-su97OSQKd9","profileContainer":"ofFfGFNEBNn1cz46XSLRo","roleText":"_2KpZznyexubKtO6T0Z26Ic"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/ProfileDisplay/style.css
// module id = 1871
// module chunks = 0